export default __webpack_public_path__ + "static/media/ppt.48ac6ee9.svg";